export const AppConfig = {
	app: {
		name: import.meta.env.VITE_APP_NAME || "ConectarApp",
		version: import.meta.env.VITE_APP_VERSION || "0.1.0",
		environment: import.meta.env.VITE_APP_ENV || "development",
		termsUrl: import.meta.env.VITE_APP_TERMS_URL || "https://conectarauto.com.ar/terminos-y-condiciones",
	},

	api: {
		cacheEnabled: import.meta.env.VITE_API_CACHE_ENABLED === "true",
		isLocal: import.meta.env.VITE_API_LOCAL === "true",
		localUrl: import.meta.env.VITE_API_LOCAL_URL || "http://localhost:4069",
		baseUrl: import.meta.env.VITE_API_BASE_URL || "http://localhost:4069",
		timeout: Number.parseInt(import.meta.env.VITE_API_TIMEOUT) || 10000,
		retryAttempts: Number.parseInt(import.meta.env.VITE_API_RETRY_ATTEMPTS) || 3,
	},

	external: {
		logoUrl: import.meta.env.VITE_LOGO_URL || "https://conectarauto.azurewebsites.net/Content/img/Logo.png",
	},

	tienda: {
		url: import.meta.env.VITE_TIENDA_URL || "https://conectarauto.com.ar/",
	},

	features: {
		notifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === "true",
		analytics: import.meta.env.VITE_ENABLE_ANALYTICS === "true",
		debug: import.meta.env.VITE_ENABLE_DEBUG === "true",
		authFacebook: import.meta.env.VITE_AUTH_FACEBOOK_ENABLED === "true",
		authApple: import.meta.env.VITE_AUTH_APPLE_ENABLED === "true",
	},

	limits: {
		maxVehiclesPerson: Number.parseInt(import.meta.env.VITE_MAX_VEHICLES_PERSON) || 3,
		maxVehiclesCompany: Number.parseInt(import.meta.env.VITE_MAX_VEHICLES_COMPANY) || 10,
		maxFileSize: Number.parseInt(import.meta.env.VITE_MAX_FILE_SIZE) || 5242880, // 5MB
	},

	isDevelopment: () => AppConfig.app.environment === "development",
	isProduction: () => AppConfig.app.environment === "production",
};
